import { Clock, MapPin, Star } from "lucide-react";
import moment from "moment";
import type React from "react";
import type { HeroQuickInfo as HeroQuickInfoType } from "@/types/hero.types";
import { DefaultCard } from "@/ui/DefaultCard";

interface HeroQuickInfoProps {
  quickInfo: HeroQuickInfoType[];
}

const iconMap = {
  clock: Clock,
  "map-pin": MapPin,
  star: Star,
};

const formatTime = (time: string) => {
  return moment(time, "HH:mm").format("h:mm A");
};

const HeroQuickInfo: React.FC<HeroQuickInfoProps> = ({ quickInfo }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
      {quickInfo.map((info) => {
        const IconComponent =
          iconMap[info.icon as keyof typeof iconMap] || Clock;
        return (
          <DefaultCard
            key={`${info.icon}-${info.title}`}
            background="subtle-glass"
            padding="md"
            size="sm"
          >
            <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-full mb-4 mx-auto">
              <IconComponent className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-white font-bold text-lg mb-2">{info.title}</h3>
            {info.duration ? (
              <p className="text-white/80">
                {formatTime(info.duration.startTime)} -{" "}
                {formatTime(info.duration.endTime)}
              </p>
            ) : (
              <p className="text-white/80">{info.description}</p>
            )}
          </DefaultCard>
        );
      })}
    </div>
  );
};

export default HeroQuickInfo;
